import { Component, Prop, h, Element } from '@stencil/core';
import { PageNode } from 'interfaces/PageNode';



@Component({
    tag: 'kdx-nav',
    styleUrl: 'kdx-nav.scss'
})
export class KdxNav {
    @Element() root: HTMLElement
    @Prop() pageNodes: string = '';
    pageNodeArray: Array<PageNode> = [];

    componentWillLoad() {
        if (this.pageNodes !== '') {
            this.pageNodeArray = JSON.parse(this.pageNodes);
        }
    }

    componentDidRender() {

        //Handle tab keypress on the last menu item
        const lastMainMenuItem = this.root.querySelector('.node.last');
        const anchorTags = lastMainMenuItem.querySelectorAll('a');
        const lastAnchorTag = anchorTags.length > 0 ? anchorTags[anchorTags.length - 1] : null;

        if (lastAnchorTag) {
            lastAnchorTag.addEventListener('keydown', event => {
                if (!event.shiftKey && event.key.toLowerCase() === 'tab') {
                    this.menuEntered('leave')
                }
            })
        }

        const mobileMenu = document.querySelector('.mobile-bottom-nav .mobile-control .menu') as HTMLAnchorElement;
        const navMenuItems = this.root.querySelector('.app-nav')
        mobileMenu.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeSearch();
            mobileMenu.classList.toggle('open');
            navMenuItems.classList.toggle('show');
        })

        
        //putting nav items in a container for mobile
        const navChildren = document.querySelectorAll('.app-nav .node .simple-children');
        if (window.innerWidth < 1199.98) {
            navChildren.forEach(child => {
                child.classList.add('container')
            })
        }

        const mediaQuery = window.matchMedia('(max-width: 1199.98px)');
        mediaQuery.addEventListener('change', () => {

            navChildren.forEach(child => {
                child.classList.toggle('container')
            })

        });
    }

    menuEntered(state) {
        if (window.innerWidth > 1199.98) {
            if (state == 'enter') {
                document.querySelector('body').classList.add('menu-entered');
            } else {
                document.querySelector('body').classList.remove('menu-entered');
            }
        }
    }

    closeSearch() {
        const mobilesearch = document.querySelector('.mobile-bottom-nav .mobile-control .search') as HTMLAnchorElement;
        const searchElements = document.querySelector('form.kdx-site-search')

        searchElements.classList.remove('show')
        mobilesearch.classList.remove('open')
    }

    onMainNavWithKeyboard(event: KeyboardEvent) {
        const target = event.target as Element;
        if (!event.shiftKey && event.key.toLowerCase() === 'tab') {
            this.menuEntered('enter')
        } else if (event.shiftKey && event.key.toLowerCase() === 'tab') {
            if (!target.closest('.node').previousElementSibling) {
                this.menuEntered('leave')
            } else if (!target.closest('.node').previousElementSibling.classList.contains('node')) {
                this.menuEntered('leave')
            } else {
                this.menuEntered('enter')
            }
        }
    }

    mobileNavToggle(nodeIndex: number) {

        const targetNodeContainer = document.querySelectorAll('.app-nav .node')[nodeIndex]

        if (targetNodeContainer) {

            document.querySelectorAll('.app-nav .node').forEach((node: HTMLElement, index: number) => {
                if (index !== nodeIndex) {

                    node.classList.remove('open');
                } else {
                    node.classList.toggle('open')
                }

            });
        }
    }

    render() {
        return (
            <div class="app-nav container">
                {this.pageNodeArray.map((node, nodeIndex) => (

                    <div class={`node${nodeIndex === this.pageNodeArray.length - 1 ? ' last' : ''}`} onMouseEnter={() => { this.menuEntered('enter') }} onMouseLeave={() => { this.menuEntered('leave') }}>
                        <div class="parent container">
                      <a href={node.UrlName} aria-label={node.Title} target={node.Target } onKeyDown={(e) => this.onMainNavWithKeyboard(e)}>
                                {node.Title}
                                {Boolean(node.Nodes && node.Nodes.length) && (<kdx-icon icon="chevron-down"></kdx-icon>)}
                            </a>
                            {Boolean(node.Nodes && node.Nodes.length) && <div role="button" tabIndex={0} class="mobile-dropdown-toggle" aria-label="Toggle Navigation Item" onClick={() => { this.mobileNavToggle(nodeIndex) }}><kdx-icon icon="chevron-down"></kdx-icon></div>}
                        </div>

                        {Boolean(node.Nodes && node.Nodes.length) && (
                            <div class="simple-children">
                                <div class="simple-children__links">
                                    <span>{node.Title}</span>
                                    {node.Nodes.map((child) => (
                                      <a href={child.UrlName} target={child.Target} aria-label={child.Title} class='title'>
                                            {child.Title}
                                        </a>
                                    ))}
                                </div>

                                {Boolean(node.CTA) && (
                                    <kdx-nav-cta CTA={node.CTA}></kdx-nav-cta>
                                )}

                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    }
}
